module.exports = __webpack_public_path__ + "static/media/IMG_1529y.c048fadd.jpg";